import { useQuery } from '@tanstack/react-query';
import { ExportersApi } from 'api';

/**
 * Custom React Query hook to fetch seller data by id
 *
 * @param {number} id
 * @param {{onError?: (error: Error) => void}} options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useGetExporter(id, { onError } = {}) {
  return useQuery({
    queryKey: ['exporter', id],
    queryFn: () =>
      ExportersApi.getById(id)
        .then((res) => res.data)
        .catch((error) => {
          typeof onError === 'function' && onError(error);
        }),
  });
}
